import { useContext } from "react"
import { RESOLUTION_RATIO } from "@utils/CONST"
import { GenerateContext } from "../../../hooks/GenerateContext"
import styles from "./index.module.scss"

const items = [
    { label: "原比例", value: "" },
    { label: "3:4", value: RESOLUTION_RATIO.THREE_FOUR },
    { label: "1:1", value: RESOLUTION_RATIO.SQUARE },
    { label: "16:9", value: RESOLUTION_RATIO.SIXTEEN_NINE },
]

const AspectRatioSelector = () => {
    const { aspectRatio, setAspectRatio } = useContext(GenerateContext)

    return (
        <div className={styles.Container}>
            <p className={styles.Title}>比例选择</p>
            <div className={styles.PickerContent}>
                {items.map((item) => (
                    <div
                        key={item.label}
                        className={`${styles.PickerItem} ${aspectRatio === item.value ? styles.actived : ''}`}
                        onClick={() => setAspectRatio(item.value)}
                    >
                        <span>{item.label}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default AspectRatioSelector
